var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showParameterWarningLabel)?_c('small',{ref:"parameterWarningLabel",staticClass:"mr-1"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'exclamation-triangle']}}),_vm._v(" "+_vm._s(_vm.sandboxWarning)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }